export const VideoEventType = {
  PLAY: 'play',
  PAUSE: 'pause',
  ENDED: 'ended',
};
export type VideoEvent = 'play' | 'stop';

export type VideoProgressData = {
  playedSeconds: number;
  played: number;
  loadedSeconds: number;
  loaded: number;
};

type BackendVideoLogResponse = {
  session: string;
  url: string;
  value: VideoEvent;
  user_id: string;
};

export type VideoLogResponse = Omit<BackendVideoLogResponse, 'user_id'> & {
  userId: string;
};

const mapBackendVideoLogResponseToVideoLogResponse = (
  data: BackendVideoLogResponse
): VideoLogResponse => ({
  session: data.session,
  url: data.url,
  value: data.value,
  userId: data.user_id,
});

export const postVideoEventMapper = (response: any): VideoLogResponse =>
  mapBackendVideoLogResponseToVideoLogResponse(response.data);
